import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApplicationAccess } from '@referrals/shared/models';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/applicationaccess`;
  }

  public getById(id: number): Observable<ApplicationAccess[]> {
    return this.http.get<ApplicationAccess[]>(this.accessPointUrl + '/source/' + id, {
      headers: this.headers,
    });
  }

  public update(payload: ApplicationAccess): Observable<ApplicationAccess> {
    console.log('svc call update', payload);
    return this.http.put<ApplicationAccess>(
      this.accessPointUrl,
      payload,
      {
        headers: this.headers,
      }
    );
  }
}
